export default __webpack_public_path__ + "static/media/dunkin.fa142793.png";